import React from 'react';
import CustomInput from '../../../component/CustomInput/CustomInput';
import { DEFAULT_LEVEL_LABELS, MAX_HIERARCHY_DEPTH } from './hierarchyUtils';

interface LevelLabelEditorProps {
  labels: string[];
  errors?: string[];
  onChange: (labels: string[]) => void;
}

const LevelLabelEditor: React.FC<LevelLabelEditorProps> = ({
  labels,
  errors = [],
  onChange,
}) => {
  const update = (index: number, value: string) => {
    const next = [...labels];
    next[index] = value;
    onChange(next);
  };

  return (
    <div className="level_label_editor">
      <div className="level_label_editor_head">
        <h4>Hierarchy levels</h4>
        <p>
          Rename the four grouping levels to match how this subject is taught.
          The first two are required; leave a later level blank to disable it.
        </p>
      </div>

      <div className="level_label_grid">
        {Array.from({ length: MAX_HIERARCHY_DEPTH }).map((_, index) => {
          const required = index < 2;
          return (
            <div className="level_label_field" key={index}>
              <label>
                {DEFAULT_LEVEL_LABELS[index]}
                {required ? (
                  <span className="text-red-500"> *</span>
                ) : (
                  <span className="level_label_optional"> (optional)</span>
                )}
              </label>
              <CustomInput
                value={labels[index] ?? ''}
                placeholder={required ? 'Required' : 'Leave blank to disable'}
                onChange={e => update(index, e.target.value)}
                error={errors[index]}
                style={{ height: 42 }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LevelLabelEditor;
